export default __webpack_public_path__ + "static/saoldisplay-mediumitalic-webfont-6067ce8f1e8e984f005383301ea2ea8e.woff";